import React from "react";
import FileBase64 from "react-file-base64";

import { ReactComponent as ErrorIcon } from "../../../assets/icons/error.svg";

import "./AccountLogo.styles.scss";

interface AccountLogoProps {
  onChange: (file: File) => void;
  src?: string;
  label?: string;
  errors?: string[];
}

export const AccountLogo: React.FC<AccountLogoProps> = ({ onChange = () => {}, src = "", errors = [] }) => {
  return (
    <div className="account-logo flex-col-fs-fs">
      <label>
        <div className="account-logo__preview flex-col-fs-fs">
          {src ? (
            <img src={src} className={"account-logo__preview-image"} alt="company logo" />
          ) : (
            <div className="account-logo__preview-wrapper flex-row-fc-fc scale-click">
              Upload Company Logo.jpg
              <FileBase64
                onDone={(data: { file: File }) => {
                  onChange(data.file);
                }}
              />
            </div>
          )}
          <div className="account-logo__text flex-row-sb-fc"></div>
        </div>
      </label>
      <div className="account-logo__titles flex-row-sb-fc">
        <span>Logo Format: JPG | PNG | Max Width: 760px</span>
        <label>
          {src ? (
            <div className="account-logo__titles-replace">
              Replace Company Logo
              <FileBase64
                onDone={(data: { file: File }) => {
                  onChange(data.file);
                }}
              />
            </div>
          ) : null}
        </label>
      </div>
      <div className="account-logo__error flex-row-fc-fc">
        {errors?.length ? (
          <span className="opacity-appearance">
            <ErrorIcon className="account-logo__error-icon" />
            {errors}
          </span>
        ) : null}
      </div>
    </div>
  );
};
